import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Container } from 'react-bootstrap';
import { Breadcrumbs } from "../Components/Breadcrumbs";
import { getNewsEvent } from "../Services/NewsService";
import Loader from "../Components/Loader";
import { format } from 'date-fns';
import Image from '../Components/Image';
import { Helmet } from "react-helmet-async";

const NewsArticle = () => {
  const params = useParams();
  const [newsDetails, setNewsDetails] = useState([]);
  const eventDate = newsDetails?.event_date ? new Date(newsDetails.event_date) : null;


  useEffect(() => {
    if (newsDetails.length === 0) {
      getNewsDetails();
    }

  }, [params.id]);

  const getNewsDetails = async () => {
    const response = await getNewsEvent(params.id);
    setNewsDetails(response);
  }

  return (
    <div>
      <Helmet>
        <title>News Article</title>
        <meta name="description" content=" Oasis Educational Institute" />
      </Helmet>

      <Breadcrumbs page="News Details" label="Home" path="/" />
      <Container style={{ marginTop: '2%', marginBottom: '5%', padding: ' 10px' }}>
        {!newsDetails ? (
          <>
            <Loader />
          </>
        ) : (
          newsDetails && (
            <div className="max-w-4xl mx-auto px-4 sm:px-6 py-6 bg-white">
            <h1 className="text-2xl sm:text-3xl font-semibold mb-4 tracking-tight">
              {newsDetails.title}
            </h1>
          
            <div className="flex flex-col sm:flex-row items-start justify-between mb-4 text-sm text-gray-500">
              <div className="flex items-center space-x-2">
                <span className="text-xl text-black-700">
                  <svg
                    className="h-5 sm:h-6 w-5 sm:w-6 text-black-400"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M12 12c2.206 0 4-1.794 4-4s-1.794-4-4-4-4 1.794-4 4 1.794 4 4 4zM12 14c-2.667 0-8 1.334-8 4v2h16v-2c0-2.666-5.333-4-8-4z"
                    />
                  </svg>
                </span>
                <span>{newsDetails?.uploaded_by}</span>
              </div>
            </div>
          
            <p className="text-sm text-black-400 mb-4 sm:mb-6">
              {eventDate ? format(eventDate, "MMMM dd, yyyy") : "Date not available"}
            </p>
          
            <div className="mb-4 sm:mb-6">
              <Image
                id={newsDetails.file_id}
                className="w-full h-auto max-h-[250px] sm:max-h-[350px] md:max-h-[430px] object-cover rounded-lg shadow-md"
              />
            </div>
          
            <div className="text-gray-600 text-sm sm:text-base leading-relaxed">
              <p>{newsDetails.description}</p>
            </div>
          </div>
          )
        )}
      </Container>
    </div>


  )
}

export default NewsArticle